import { Expose } from 'class-transformer';
import { Setting } from '../models/Setting';
import { ResponseBase } from './base/ResponseBase';

export class SettingsResponse extends ResponseBase {
        @Expose({ name: 'results' })
        settings?: Array<Setting>;
}